/* eslint @typescript-eslint/no-unused-vars: 0 */

/**
 * The above line 'eslint' is to disable the errors in this file for now, as QPR is in a state of flux and not working.
 * We are waiting to come up with a plan to address this in the future.
 *
 * If re-implementing QPR, please remove this and the above 'eslint' comment
 *
 * Aran Mason - 2nd November 2022
 */

// core
import React from "react";

// components
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";

// providers
import Icon from "../../../../common/components/Icon/Icon";
import TableContainer from "../../TableList/TableContainer";
import InsurerLogo from "../../../../common/components/InsurerLogo/InsurerLogo";
import { IQuoteCardResult } from "../../../interfaces/results/IQuoteCardResult";
import TableRow from "../../TableList/TableRow/TableRow";
import StarRating from "../../../../common/components/StarRating/StarRating";
import TableCell from "../../TableList/TableCell/TableCell";
import useWindowDimensions from "../../../../common/hooks/useWindowDimensions";
import TableSection from "../../TableList/TableSection/TableSection";
import ProductType from "../../../../common/interfaces/enums/ProductType";

interface IPolicyFeatureRatingsModal {
    results: IQuoteCardResult[];
    isOpen: boolean;
    onClose: () => void;
}

const whatMakesAQPRRating: string[] = [
    "How well is the policy worded?",
    "How likely is a policy feature to be claimed on?",
    "How many times can it be claimed?",
    "How much can you be paid?"
];

const PolicyFeatureRatingsModal: React.FC<IPolicyFeatureRatingsModal> = (props) => {
    const { results, isOpen, onClose } = props;

    const { isTabletPortrait } = useWindowDimensions();

    const ratings = results
        .sort(
            (a, b) =>
                b.ratings.provider.ratingInfo.totalPercentRating -
                a.ratings.provider.ratingInfo.totalPercentRating
        )
        .filter(
            (val, index, self) =>
                self.findIndex(
                    (ref) => ref.result.providerId === val.result.providerId
                ) === index && !val.result.errors
        );

    return (
        <React.Fragment>
            <LModal
                Header={() => <ModalHeader onClose={onClose} title="Policy features" />}
                calcHeightMode="auto"
                width="wide"
                isOpen={isOpen}
                onClose={onClose}>
                {() => (
                    <React.Fragment>
                        <Icon
                            id="QPRLogo"
                            width="max-content"
                            height="auto"
                            style={{
                                minWidth: "50%",
                                maxWidth: "100%",
                                width: "max-content"
                            }}
                            className="gap-l"
                        />
                        <h3>In-depth policy analysis at a glance</h3>

                        <p>
                            Our independent policy feature ratings are from Quality
                            Product Research (QPR). QPR compares policy features, then
                            rates each policy, with the top rated policy scoring 100%. The
                            ratings give you a quick and effective way to check policy
                            quality.
                        </p>
                        <h4>What makes a QPR rating?</h4>
                        <ul
                            style={{
                                listStyle: "none",
                                paddingLeft: 0
                            }}>
                            {whatMakesAQPRRating.map((item) => {
                                return (
                                    <li key={item}>
                                        <Icon height="14px" width="14px" id="GreenTick" />
                                        &nbsp;{item}
                                    </li>
                                );
                            })}
                        </ul>
                        {/* <TableContainer
                            title="Current overall policy feature ratings*"
                            footnote="* As at 24th August 2022">
                            <TableSection>
                                {ratings.map((result) => {
                                    if (isTabletPortrait) {
                                        return (
                                            <TableRow
                                                key={`${result.baseProductId}-Mobile`}>
                                                <TableCell className="layout-flex-column">
                                                    <InsurerLogo
                                                        includesAboutInsurerModal
                                                        providerId={
                                                            result.result.providerId
                                                        }
                                                    />
                                                    <span>{result.productName}</span>
                                                    <StarRating
                                                        rating={
                                                            result.ratings.provider
                                                                .ratingInfo
                                                                .totalPercentRating * 5
                                                        }
                                                        maxRating={5}
                                                        notRatedText="Not yet rated by QPR"
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }

                                    return (
                                        <TableRow key={result.baseProductId}>
                                            <TableCell>
                                                <InsurerLogo
                                                    includesAboutInsurerModal
                                                    providerId={result.result.providerId}
                                                />
                                            </TableCell>
                                            <TableCell>{result.productName}</TableCell>
                                            <TableCell>
                                                <StarRating
                                                    rating={
                                                        result.ratings.provider.ratingInfo
                                                            .totalPercentRating * 5
                                                    }
                                                    maxRating={5}
                                                    notRatedText="Not yet rated by QPR"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableSection>
                        </TableContainer> */}
                        <span className="text-light text-font-size-xs">
                            Note: QPR ratings are not advice and are not a recommendation
                            to purchase or not purchase any insurance policy.
                        </span>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default PolicyFeatureRatingsModal;
